import { Button, HStack, Spacer, Stack, Text } from '@chakra-ui/react';

import { useLabelsBar } from '@util/hooks/labels.hooks';
import LabelsContainer from './labels-container.component';

const LabelsBarReadOnly = ({ labels, children, ...props }) => {
  const { containerRef, hiddenCount, isExpanded, setIsExpanded } = useLabelsBar(labels);
  return (
    <Stack
      w='full'
      {...props}
    >
      <LabelsContainer
        ref={containerRef}
        labels={labels}
        isExpanded={isExpanded}
      />
      <HStack>
        {(isExpanded || hiddenCount > 0) && (
          <Button
            variant='reskinGhost'
            colorScheme='surface'
            size='xs'
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <Text variant='label-reg-md'>{isExpanded ? 'View less' : `+${hiddenCount} more`}</Text>
          </Button>
        )}

        <Spacer />
        {children}
      </HStack>
    </Stack>
  );
};

export default LabelsBarReadOnly;
